import MediaComponentFactory from 'app/components/mediaModule/content/MediaComponentFactory';
import React, { useCallback, useMemo } from 'react';
import SwipeableViewsStepper from 'app/components/swipeableViews/SwipeableViewsStepper';
import { View, Wrapper } from 'app/components/mediaModule/content/contentStyles';
import splitArrayIntoChunks from 'app/components/swipeableViews/splitArrayIntoChunks';
import MediaModulePlaceholder from 'app/components/mediaModule/MediaModulePlaceholder';
import { useLocation } from 'react-router';
import { DistrictMainPageModuleType, useDistrictMainPageTracking } from 'app/components/district/news/DistrictMainPageTracking';
import isInvalidViewData from 'app/components/swipeableViews/isInvalidViewData';
export default function MediaModuleContent(_ref) {
  let {
    data,
    districtName
  } = _ref;
  const location = useLocation();
  const {
    trackClickedItemPage,
    updateTrackingData
  } = useDistrictMainPageTracking();
  const viewData = useMemo(() => {
    return splitArrayIntoChunks(data);
  }, [data]);
  const renderView = useCallback(_ref2 => {
    let {
      index
    } = _ref2;
    const handleOnClick = pageIndex => {
      trackClickedItemPage(DistrictMainPageModuleType.MEDIA, pageIndex);
    };
    if (isInvalidViewData(viewData, index)) {
      return null;
    }
    return /*#__PURE__*/React.createElement(View, {
      onClick: () => handleOnClick(index),
      key: "media-view-".concat(index)
    }, viewData[index].map((mediaData, elementIndex) => {
      if (!mediaData) {
        return /*#__PURE__*/React.createElement(Wrapper, {
          key: "media-filler-".concat(elementIndex)
        });
      }
      return MediaComponentFactory.create(mediaData);
    }));
  }, [trackClickedItemPage, viewData]);
  const callback = useCallback(data => updateTrackingData(DistrictMainPageModuleType.MEDIA, data), [updateTrackingData]);
  if (!data.length) {
    return /*#__PURE__*/React.createElement(MediaModulePlaceholder, {
      districtName: districtName,
      pathname: location.pathname
    });
  }
  return /*#__PURE__*/React.createElement(SwipeableViewsStepper, {
    callback: callback,
    stepCount: viewData.length,
    viewRender: renderView,
    "data-sentry-element": "SwipeableViewsStepper",
    "data-sentry-component": "MediaModuleContent",
    "data-sentry-source-file": "MediaModuleContent.tsx"
  });
}